// Msal imports
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import {
  InteractionStatus,
  InteractionType,
  InteractionRequiredAuthError,
} from "@azure/msal-browser";
import { loginRequest } from "../authConfig";

// Sample app imports
import { RegisterForm } from "../components/Register/RegisterForm";
import { Loading } from "../components/Loading";
import { ErrorComponent } from "../components/ErrorComponent";

const RegisterContent = () => {
  return <RegisterForm />;
};

export function Register() {
  const authRequest = {
    ...loginRequest,
  };

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
      errorComponent={ErrorComponent}
      loadingComponent={Loading}
    >
      <RegisterContent />
    </MsalAuthenticationTemplate>
  );
}
